import DriverStatus from 'components/orders/DriverStatus/DriverStatus.styled';

export default DriverStatus;
